import { useEffect, useRef, useState } from 'react'

type UseSkeletonVisibilityInput = {
  isLoading: boolean
  minVisibleMs?: number
}

export const useSkeletonVisibility = ({
  isLoading,
  minVisibleMs = 920,
}: UseSkeletonVisibilityInput) => {
  const [isSkeletonVisible, setSkeletonVisible] = useState(() => isLoading)
  const loadingStartedAtRef = useRef<number | null>(isLoading ? Date.now() : null)

  useEffect(() => {
    if (isLoading) {
      loadingStartedAtRef.current = Date.now()
      setSkeletonVisible(true)
      return
    }

    if (!isSkeletonVisible) return

    const loadingStartedAt = loadingStartedAtRef.current ?? Date.now()
    const elapsed = Date.now() - loadingStartedAt
    const remaining = Math.max(minVisibleMs - elapsed, 0)

    const timeoutId = window.setTimeout(() => {
      setSkeletonVisible(false)
      loadingStartedAtRef.current = null
    }, remaining)

    return () => window.clearTimeout(timeoutId)
  }, [isLoading, isSkeletonVisible, minVisibleMs])

  return isSkeletonVisible
}
